// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/fr-BE';

import landingFreeBundle from './LandingFreeBundle';

// Tenant-specific styles
import '../../../scss/site/pages/LandingFreeBundle/LandingFreeBundle.twh.scss';

landingFreeBundle(i18n);
